import styled from 'styled-components';

export const BKPayLogoButton = styled.button`
  border: none;
  background: none;
  display: flex;
  padding-left: 7px;
`;
